import { create } from "zustand";
import { logEvent } from "@um/ui";

interface SparkState {
  isOpen: boolean;
  /** Open the Spark Story dialog (mounted once at the app root). */
  openSpark: () => void;
  close: () => void;
}

export const useSparkStore = create<SparkState>((set) => ({
  isOpen: false,

  openSpark: () => {
    logEvent("um_spark_story_opened", {
      path: window.location.pathname,
    });
    set({ isOpen: true });
  },

  close: () => set({ isOpen: false }),
}));
